/* tslint:disable */

declare var Object: any;
export interface ProductImagesInterface {
  "id"?: number;
  "name"?: string;
  "base64"?: string;
  "model_name"?: string;
  "model_id"?: number;
  "model"?: string;
  "status"?: string;
  "gps_position_id"?: number;
  "file"?: number;
  "image"?: any;
}

export class ProductImages implements ProductImagesInterface {
  "id": number;
  "name": string;
  "base64": string;
  "model_name": string;
  "model_id": number;
  "model": string;
  "status": string;
  "gps_position_id": number;
  "file": number;
  "image": any;
  constructor(data?: ProductImagesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductImages`.
   */
  public static getModelName() {
    return "ProductImages";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductImages for dynamic purposes.
  **/
  public static factory(data: ProductImagesInterface): ProductImages{
    return new ProductImages(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductImages',
      plural: 'ProductImages',
      path: 'ProductImages',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "base64": {
          name: 'base64',
          type: 'string'
        },
        "model_name": {
          name: 'model_name',
          type: 'string'
        },
        "model_id": {
          name: 'model_id',
          type: 'number'
        },
        "model": {
          name: 'model',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "gps_position_id": {
          name: 'gps_position_id',
          type: 'number'
        },
        "file": {
          name: 'file',
          type: 'number'
        },
        "image": {
          name: 'image',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ProductImages.ts